import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6" data-id="mta3gqq1e" data-path="src/components/Breadcrumbs.tsx">
      <a href="/" className="flex items-center hover:text-blue-600 transition-colors" data-id="nh0szscsx" data-path="src/components/Breadcrumbs.tsx">
        <Home className="w-4 h-4" data-id="7gxscqt54" data-path="src/components/Breadcrumbs.tsx" />
      </a>
      {items.map((item, index) =>
      <React.Fragment key={index} data-id="hs2mzyn35" data-path="src/components/Breadcrumbs.tsx">
          <ChevronRight className="w-4 h-4 text-gray-400" data-id="vwn74zn74" data-path="src/components/Breadcrumbs.tsx" />
          {item.href ?
        <a href={item.href} className="hover:text-blue-600 transition-colors" data-id="cn001gqwj" data-path="src/components/Breadcrumbs.tsx">
              {item.label}
            </a> :

        <span className="text-gray-800 font-medium" data-id="wjb87mr7s" data-path="src/components/Breadcrumbs.tsx">{item.label}</span>
        }
        </React.Fragment>
      )}
    </nav>);

};

export default Breadcrumbs;